import { useState } from 'react';
//import './css/Education.css'; 
import { translateFormacao } from '../../data/translateFormacao';
import { IconImagem } from '../../data/icons';
// IMPORTANTE: Adicione o caminho do seu IconImagem aqui


const uiText = {
  pt: { titulo: "EDUCAÇÃO" },
  en: { titulo: "EDUCATION" }
};

function Education({ language }) {
    const ui = uiText[language];
    const formacoes = translateFormacao[language];
    
    // Estado do Modal de Imagem
    const [imagemAberta, setImagemAberta] = useState(null);
    
    // NOVO: Estado para saber qual bolinha está com o mouse em cima
    const [hoveredIndex, setHoveredIndex] = useState(null);

    const isEnglish = language === 'en';

    return (
        <section className="education-section" id="education">
            <div className='box-title-section'>
                <p className='back-legend'>{ui.titulo}</p>
                <h2 className='front-legend'>{ui.titulo}</h2>
            </div>
            
            <div className="alt-timeline-container">
                <div className="alt-track"></div>

                <div className="alt-grid">
                    {formacoes.map((formacao, index) => {
                        // Verifica se deve liberar o recurso de imagem para ESTE item
                        const temImagemNoIngles = isEnglish && formacao.imagem;

                        return (
                            <div className={`alt-item ${index % 2 === 0 ? 'item-top' : 'item-bottom'}`} key={formacao.id}>
                                
                                <div className={`alt-stem ${index < 2 ? 'stem-active' : 'stem-gray'}`}></div>
                                
                                <div 
                                    className={`alt-dot ${index < 2 ? 'active-pulse' : 'dot-finished'} ${temImagemNoIngles ? 'clickable' : ''}`}
                                    // Clique abre o modal
                                    onClick={() => { 
                                        if (temImagemNoIngles) setImagemAberta(formacao.imagem); 
                                    }}
                                    // NOVO: Eventos de Mouse para controlar o hover
                                    onMouseEnter={() => {
                                        if (temImagemNoIngles) setHoveredIndex(index);
                                    }}
                                    onMouseLeave={() => {
                                        if (temImagemNoIngles) setHoveredIndex(null);
                                    }}
                                    title={temImagemNoIngles ? "View institution photo" : ""}
                                >
                                    {/* A MÁGICA AQUI: Se o mouse estiver em cima E for inglês, mostra o IconImagem. Senão, mostra o ícone original. */}
                                    {hoveredIndex === index ? <IconImagem/> : formacao.icone}
                                </div>
                                
                                <div className="alt-content">
                                    <span className={`alt-date ${index < 2 ? 'date-active' : ''}`}>
                                        {formacao.periodo}
                                    </span>
                                    <h4 className="alt-role">{formacao.curso}</h4>
                                    <div className="alt-company">{formacao.instituicao}</div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>

            {/* MODAL DA IMAGEM */}
            {imagemAberta && (
                <div className="image-modal-overlay" onClick={() => setImagemAberta(null)}>
                    <div className="image-modal-content" onClick={(e) => e.stopPropagation()}>
                        <button className="close-modal-btn" onClick={() => setImagemAberta(null)}>✕</button>
                        <img src={imagemAberta} alt="Institution" className="modal-img" />
                    </div>
                </div>
            )}
        </section>
    );
}

export default Education;